<template>
  <div v-if="node" class="site-map-node">
    <SiteLink :link="linkObj" class="site-map-node__link">{{ node.title }}</SiteLink>
    <div v-if="hasChildren" class="site-map-node__children">
      <SiteMap v-for="child in node.children" :key="child.id" :node="child" />
    </div>
  </div>
  <div v-else class="site-map">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <div class="site-map__list">
        <SiteMap :node="siteMap" />
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { onMounted, reactive, computed, toRefs } from 'vue';
import api from '@/api';

export default {
  name: 'SiteMap',
  props: {
    node: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const state = reactive({
      siteMap: {},
    });
    const methods = {
      async getSiteMap() {
        const [res, ex] = await api.siteMap.getSiteMap({});
        state.siteMap = ex;
        console.log('state.siteMap===>', state.siteMap);
      },
    };

    onMounted(() => {
      if (!props.node) {
        methods.getSiteMap();
      }
    });

    const linkObj = computed(() => ({
      value: {
        href: props.node?.url,
        text: props.node?.title,
      },
    }));
    const hasChildren = computed(() => props.node?.children?.length > 0);

    return {
      ...methods,
      ...toRefs(state),
      linkObj,
      hasChildren,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.site-map {
  padding: 40px 0;

  @include tablet-landscape {
    padding: 60px 0;
  }
}

.site-map-node {
  display: flex;
  flex-direction: column;
  gap: 5px;

  &__link {
    font-size: 16px;
  }

  &__children {
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding-left: 15px;
  }
}
</style>
